/* Guest Pages */
const PageNotFound = () => import('@/pages/errors/PageNotFound')
const SignIn = () => import('@/pages/guest/SignIn')
const ForgotPassword = () => import('@/pages/guest/ForgotPassword')
const ChangePassword = () => import('@/pages/guest/ChangePassword')

/* Authenticated Pages */
const Home = () => import('@/pages/home/Home')

/* Home Pages */
// const Dashboard = () => import('@/pages/home/dashboard/Dashboard')
const AccountRequest = () => import('@/pages/home/account-request/AccountRequest')
const RegisteredAccounts = () => import('@/pages/home/registered-accounts/RegisteredAccount')
// const Distributor = () => import('@/pages/home/distributor/Distributor')
const AccountOverview = () => import('@/pages/home/account-overview/AccountOverview')

/* Route Pages */
const RouterList = () => import('@/pages/home/router/List.vue')
const RouterCreate = () => import('@/pages/home/router/Create.vue')
const RouterUpdate = () => import('@/pages/home/router/Update.vue')

const NotificationPost = () => import('@/pages/home/notif/NotificationPost')
const NotificationCreate = () => import('@/pages/home/notif/NotificationCreate')
const NotificationEdit = () => import('@/pages/home/notif/NotificationEdit')

const Users = () => import('@/pages/home/user/Users')
const UserProfile = () => import('@/pages/home/user/UserProfile')

/* Distributor Pages */
// const DistributorForm = () => import('@/pages/home/distributor/DistributorForm')

/* Account Request Pages */
const AccountRequestForm = () => import('@/pages/home/account-request/AccountRequestForm')

/* Registered Request Pages */
const RegisteredAccountForm = () => import('@/pages/home/registered-accounts/RegisteredAccountForm')

export default [
    ...middleware('guest', [
        {
            path: '/signin',
            name: 'signin',
            component: SignIn
        },

        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: ForgotPassword
        },

        {
            path: '/change-password',
            name: 'change-password',
            component: ChangePassword
        },
    ]),

    ...middleware('auth', [
        {
            path: '/',
            component: Home,
            redirect: '/account-request',
            children: [
                // {
                //     path: '/dashboard',
                //     name: 'dashboard',
                //     component: Dashboard,
                //     meta: {
                //         header: 'Dashboard'
                //     }
                // },

                {
                    path: '/account-request',
                    name: 'account-request',
                    component: AccountRequest,
                    meta: {
                        header: 'Account Request',
                        permission: 'admin'
                    }
                },

                {
                    path: '/registered-accounts',
                    name: 'registered-accounts',
                    component: RegisteredAccounts,
                    meta: {
                        header: 'Registered Accounts'
                    }
                },

                // {
                //     path: '/distributor',
                //     name: 'distributor',
                //     component: Distributor,
                //     meta: {
                //         header: 'Distributor',
                //         permission: 'admin'
                //     }
                // },

                {
					path: '/router-list',
					name: 'router-list',
					component: RouterList,
					meta: {
						header: 'Registered Routers'
					}
				},

                {
                    path: '/notification-post',
                    name: 'notification-post',
                    component: NotificationPost,
                    meta: {
                        title: 'Notification Posts'
                    }
                },
        
                {
                    path: '/notification-post/create',
                    name: 'create-notification',
                    component: NotificationCreate,
                    meta: {
                        title: 'Create Notification',
                        origin: [{ name: 'notification-post', text: 'Notification Posts' }]
                    }
                },
        
                {
                    path: '/notification-post/edit/:notificationId',
                    name: 'edit-notification',
                    component: NotificationEdit,
                    props: true,
                    meta: {
                        title: 'Edit Notification',
                        origin: [{ name: 'notification-post', text: 'Notification Posts' }]
                    }
                },

                {
					path: '/users',
					name: 'users',
					component: Users,
					meta: {
						title: 'Users'
					}
				}
            ]
        },

        {
            path: '/user-profile/:id',
            name: 'user-profile',
            component: UserProfile,
            props: true,
            meta: {
                // header: 'User Profile',

                breadcrumb: {
                    name: 'User Profile',
                    homeLink: '/users'
                },
            }
        },

        {
            path: '/account-overview/:id',
            name: 'account-overview',
            component: AccountOverview,
            meta: {
                header: 'Account Overview',

                breadcrumb: {
                    name: 'Account Overview',
                    homeLink: '/account-request'
                },
            }
        },

        // {
        //     path: '/distributor/create',
        //     component: DistributorForm,
        //     name:'create-distributor',
        //     meta: {
        //         header: 'Create Account',
        //         tab: 'Register'
        //     }
        // },

        // {
        //     path: '/distributor/edit/:id',
        //     component: DistributorForm,
        //     name: 'edit-distributor',
        //     props: true,
        //     meta: {
        //         header: 'Edit Account',
        //         tab: 'Edit'
        //     }
        // },

        {
            path: '/account-request/create',
            component: AccountRequestForm,
            name: 'create-account-request',
            meta: {
                header: 'Create Account',
                tab: 'Register'
            }
        },

        {
            path: '/account-request/approve/:id',
            component: AccountRequestForm,
            name: 'approve-account-request',
            props: true,
            meta: {
                header: 'Approve Account',
                tab: 'Approve'
            }
        },

        {
            path: '/registed-accounts/create',
            component: RegisteredAccountForm,
            name: 'create-registered-account',
            meta: {
                header: 'Create Account',
                tab: 'Register'
            }
        },

        {
            path: '/registered-accounts/edit/:id',
            component: RegisteredAccountForm,
            name: 'edit-registered-account',
            props: true,
            meta: {
                header: 'Update Account',
                tab: 'Approve'
            }
        },

        {
            path: '/router/create',
            name: 'router-create',
            component: RouterCreate,
            meta: {
                header: 'Manage Router'
            }
        },

        {
            path: '/router/update/:id',
            name: 'router-update',
            component: RouterUpdate,
            props: true,
            meta: {
                header: 'Manage Router'
            }
        },

        {
			path: '/remote/:clientId',
			component: () => import('@/pages/home/remote/Home'),
			name: 'home',
			children: [
				
				{
					path: 'session',
					name: 'session',
					component: () => import('@/pages/home/remote/SessionList'),
					meta: {}
				},

				// {
				// 	path: 'session/create',
				// 	name: 'session-create',
				// 	component: () => import('@/pages/home/remote/SessionCreate'),
				// 	meta: {
				// 		origin: 'dashboard'
				// 	}
				// },

				// {
				// 	path: 'session/create-custom',
				// 	name: 'session-create-custom',
				// 	component: () => import('@/pages/home/remote/SessionCreateCustom'),
				// 	meta: {
				// 		origin: 'session-create'
				// 	}
				// },

				// {
				// 	path: 'session/create-prebuilt',
				// 	name: 'session-create-prebuilt',
				// 	component: () => import('@/pages/home/remote/SessionCreatePrebuilt'),
				// 	meta: {
				// 		origin: 'session-create'
				// 	}
				// },

				// {
				// 	path: 'session/edit/:sessionId',
				// 	name: 'session-edit',
				// 	component: () => import('@/pages/home/remote/SessionEdit'),
				// 	meta: {
				// 		origin: ''
				// 	}
				// },

				// {
				// 	path: '/session/view/:clientId/:sessionId/:sessionType',
				// 	name: 'session-view',
				// 	component: () => import('@/pages/home/remote/SessionView'),
				// 	meta: {
				// 		origin: 'session',
				// 		headless: true
				// 	}
				// },

				// {
				// 	path: 'session/view-prebuilt/:clientId/:sessionId',
				// 	name: 'session-view-prebuilt',
				// 	props: true,
				// 	component: () => import('@/pages/home/remote/SessionViewPrebuilt'),
				// 	meta: {
				// 		origin: 'session',
				// 		headless: true
				// 	}
				// },

				// {
				// 	path: 'session/school-solution-view/:clientId/:sessionId',
				// 	name: 'session-school-solution-view',
				// 	props: true,
				// 	component: () => import('@/pages/home/remote/SessionSchoolSolutionView'),
				// 	meta: {
				// 		origin: 'session',
				// 		headless: true
				// 	}
				// },

				// {
				// 	path: 'session/view/:sessionId/:userId/:date',
				// 	name: 'user-view',
				// 	component: () => import('@/pages/home/remote/SessionUser'),
				// 	props: true,
				// 	meta: {
				// 		origin: ''
				// 	}
				// },
			]
		}
    ]),

    ...middleware('*', [
        {
			path: '/generate-report',
            name: 'generate-report',
            component: () => import('@/pages/all/pdf-report/GenerateReport'),
            props: true
		},

        {
			path: '/user-display',
			name: 'user-display',
			component: () => import('@/pages/home/remote/SessionUserDisplay'),
			meta: {
				headless: true
			}
		},
        
        {
            path: '*',
            name: 'PageNotFound',
            component: PageNotFound,
        },
    ])
]

function middleware(middleware, routes) {
    // setting middleware for every route
    routes.forEach(route => {
        if (route.children) {
            route.children.forEach(child => child.meta = { ...child.meta, middleware })
        }

        route.meta = {
            ...route.meta,
            middleware
        }
    })

    return routes
}
